// extracted by css-extract-rspack-plugin
module.exports =  {"rootSection":"ac9b6c3efa","deletePetLink":"ffde257111"};